import { ICountry } from 'models';
import { Moment } from 'moment';

export interface User {
  email: string;
  first_name: string;
  last_name: string;
  name: string;

  payment_terms: number;
}

// TODO: Could be a shared library

export enum OrganizationUserStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  Invited = 'Invited',
}

export enum InvitationStatus {
  Pending = 'Pending',
  Accepted = 'Accepted',
}

export interface NewUser {
  id: string;
  initials: string;
  firstName: string;
  lastName: string;
  fullName: string;
  color: string;
  email: string;
  isEmailConfirmed: boolean;
  emailConfirmedAt: Date;
  gender: string;
  dob: Date;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  country: ICountry;
  postcode: string;
  state: State;
  timezone: string;
  abn: string;
  isGstRegistered: boolean; // TODO: This needs to be removed from here
  paymentTerms: number;
  bankName: string;
  bankBsb: string;
  bankAccountNumber: string;
  createdAt: Moment;
  lastLoginAt?: Moment;
  isAdmin: boolean;

  // Not persistent props in the backend
  status?: OrganizationUserStatus;
  trialEndDate?: Date;
  // Because of organization user
  isDisabled: boolean;
  disabledAt?: Moment;
  invitationStatus?: string;
  invitationAcceptedAt?: Moment;

  // Frontend only
  completed: boolean;
}

export type IUser = NewUser;

export interface State {
  name: string;
  code: string; // ISO i.e AU-NSW
}
